/* ==========================================================================
   Literals > Searcher
   ========================================================================== */

const getCommonLiterals = require('../base/prototype');

const searcherLiterals = {
    es: {
        adult: 'adulto',
        adults: 'adultos',
        child: 'niño',
        children: 'niños',
        baby: 'bebé',
        babies: 'bebés',
        passenger: 'pasajero',
        passengers: 'pasajeros',
        mascota: 'con mascota',
        ninguno: 'ninguno',
        young: 'joven',
        youngs: 'jovenes',
        senior: 'mayor',
        seniors: 'mayores'
    },
    pt: {
        adult: 'adulto',
        adults: 'adultos',
        child: 'crianças',
        children: 'crianças',
        baby: 'bebé',
        babies: 'bebés',
        passenger: 'passageiro',
        passengers: 'passageiros',
        mascota: 'com pet',
        ninguno: 'nenhum',
        young: 'jovem',
        youngs: 'jovens',
        senior: 'maior',
        seniors: 'maiores'
    },
    it: {
        adult: 'adulto',
        adults: 'adulti',
        child: 'bambino',
        children: 'bambini',
        baby: 'neonato',
        babies: 'neonati',
        passenger: 'passeggero',
        passengers: 'passeggeri',
        mascota: 'con mascotte',
        ninguno: 'nessuno',
        young: 'giovane',
        youngs: 'giovani',
        senior: 'senior',
        seniors: 'seniors'
    },
    de: {
        adult: 'erwachsener',
        adults: 'erwachsene',
        child: 'kind',
        children: 'kinder',
        baby: 'baby',
        babies: 'babys',
        passenger: 'passagier',
        passengers: 'passagiere',
        mascota: 'mit Haustier',
        ninguno: 'keiner',
        young: 'junger',
        youngs: 'Jugendliche',
        senior: 'senior',
        seniors: 'seniors'
    },
    fr: {
        adult: 'adulte',
        adults: 'adultes',
        child: 'enfant',
        children: 'enfants',
        baby: 'bébé',
        babies: 'bébés',
        passenger: 'passager',
        passengers: 'passagers',
        mascota: 'avec animal',
        ninguno: 'aucun',
        young: 'jeune',
        youngs: 'jeunes',
        senior: 'major',
        seniors: 'majors'
    },
    br: {
        adult: 'adulto',
        adults: 'adultos',
        child: 'niño',
        children: 'niños',
        baby: 'bebê',
        babies: 'bebês',
        passenger: 'passageiro',
        passengers: 'passageiros',
        mascota: 'com pet',
        ninguno: 'nenhum',
        young: 'jovem',
        youngs: 'jovens',
        senior: 'maior',
        seniors: 'maiores'
    },
    en: {
        adult: 'adult',
        adults: 'adults',
        child: 'child',
        children: 'children',
        baby: 'baby',
        babies: 'babies',
        passenger: 'passenger',
        passengers: 'passengers',
        mascota: 'con mascota',
        ninguno: 'ninguno',
        young: 'young',
        youngs: 'youngs',
        senior: 'senior',
        seniors: 'seniors'
    },
    fi: {
        adult: 'aikuinen',
        adults: 'aikuiset',
        child: 'lapsi',
        children: 'lapset',
        baby: 'vauva',
        babies: 'vauva',
        passenger: 'matkustaja',
        passengers: 'matkustajien',
        mascota: 'with pet',
        ninguno: 'none',
        young: 'nuorimies',
        youngs: 'nuoria',
        senior: 'vanhuksia',
        seniors: 'suurempi'
    },
    mx: {
        adult: 'adulto',
        adults: 'adultos',
        child: 'niño',
        children: 'niños',
        baby: 'bebé',
        babies: 'bebés',
        passenger: 'pasajero',
        passengers: 'pasajeros',
        mascota: 'con mascota',
        ninguno: 'ninguno',
        young: 'joven',
        youngs: 'jovenes',
        senior: 'mayor',
        seniors: 'mayores'
    },
    ru: {
        adult: 'взрослый',
        adults: 'взрослых',
        child: 'ребенок',
        children: 'детей',
        baby: 'младенец',
        babies: 'младенцев',
        passenger: 'пассажир',
        passengers: 'пассажиры',
        mascota: 'с домашним животным',
        ninguno: 'никто',
        young: 'молодой человек',
        youngs: 'молодежь',
        senior: 'пожилой',
        seniors: 'больший'
    }
};

module.exports = function Fn(language = 'es') {
    const commonLiterals = getCommonLiterals(language);

    return { ...commonLiterals, ...(searcherLiterals[language] || {}) };
};
